<template>
  <el-dialog
    class="customDialogForm"
    width="600px"
    title="绑定域名"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <el-form
      autocomplete="on"
      ref="BindingDomainForm"
      label-position="left"
      :model="domainForm"
      label-width="100px"
      class="customForm"
      :rules="rules"
      @submit.native.prevent
    >
      <div class="dialog-intro dialog-intro--success">
        请先将自定义域名的 CNAME 解析到你选择的默认域名，自定义域名才会生效。
      </div>
      <el-form-item prop="ruleID" label="选择域名:">
        <el-select
          v-model="domainForm.ruleID"
          placeholder="请选择域名"
        >
          <el-option
            v-for="item in Domain"
            :key="item.ruleID"
            :label="item.domain"
            :value="item.ruleID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="domain" label="自定义域名:">
        <el-input
          v-model="domainForm.domain"
          placeholder="请输入自定义域名"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { errorHandle } from '@/utils/error';
import { validateDomain } from '@/utils/validate';

export default {
  name: 'DialogValidation',
  props: {
    dialogVisible: Boolean,
    Domain: Array,
    appID: String,
    marketID: String
  },
  data() {
    const domainRules = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('自定义域名不能为空'));
      } else if (!validateDomain(value)) {
        callback(new Error('域名格式：www.baidu.com'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        ruleID: [{ required: true, message: '选择域名', trigger: 'blur' }],
        domain: [
          { required: true, message: '自定义域名不能为空', trigger: 'blur' },
          { validator: domainRules, trigger: 'blur' }
        ]
      },
      domainForm: {
        ruleID: '',
        domain: ''
      },
      loading: false
    };
  },
  mounted() {},
  methods: {
    handleSubmit() {
      this.$refs.BindingDomainForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const obj = { appID: this.appID };
          let interfaceName = 'fetchEnterpriseDeliveryBindingDomains';
          if (this.marketID) {
            interfaceName = 'fetchStoreDeliveryBindingDomains';
            obj.marketID = this.marketID;
          }
          this.$store
            .dispatch(interfaceName, Object.assign({}, obj, this.domainForm))
            .then(() => {
              this.$message.success('域名绑定成功');
              this.$emit('handleClose', true);
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
              errorHandle(err);
            });
        }
      });
    },
    handleClose() {
      this.$emit('handleClose');
      this.$refs.BindingDomainForm.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.input-with-select .el-input-group__prepend {
  background: #f9f9f9;
}

::v-deep .customForm {
  .el-form-item__content {
    .el-select {
      width: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/BindingDomain/index.vue